var _templateObject, _templateObject2, _templateObject3, _templateObject4;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
// @ts-nocheck
import React, { useContext, useEffect } from 'react';
import styled from '@emotion/styled';
import { css } from '@emotion/css';
import { NtqToolbarContext } from "./NtqToolbarProvider";
import { Dropdown, Space } from 'antd';
import styles from "./index.module.css";
import logo from "./images/logo.png";
import Impersonation from "./Impersonation";
var Container = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: fixed;\n  top: 0;\n  background-color: #000;\n  display: flex;\n  height: 50px;\n  width: 100%;\n  color: white;\n  padding: 0 16px;\n  z-index: 100000000;\n"])));
var Right = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  margin-left: auto;\n  align-items: center;\n"])));
var Left = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n"])));
var bodyClass = css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  .ant-layout-header,\n  .ant-layout-sider {\n    margin-top: 50px;\n  }\n"])));
var url = '/ntq_tools';
var NtqToolbar = function NtqToolbar(props) {
  var _config$i18n, _config$i18n3, _config$i18n5;
  var _props$enabled = props.enabled,
    enabled = _props$enabled === void 0 ? true : _props$enabled;
  var config = useContext(NtqToolbarContext);
  if (!enabled) return null;
  var onRefresh = function onRefresh() {
    fetch("".concat(url, "/translation/refresh"));
  };
  useEffect(function () {
    if (enabled) {
      document.body.classList.add(bodyClass);
      document.body.classList.add('ntq-toolbar-enabled');
      return function () {
        return document.body.classList.remove(bodyClass);
      };
    }
  });

  // @ts-ignore
  var onFeatureToggle = function onFeatureToggle(option) {
    return function () {
      return config.onI18nConfigChange(option, !(config !== null && config !== void 0 && config.i18n) ? true : !config.i18n[option]);
    };
  };
  var items = [{
    label: /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("span", {
      className: "".concat(styles.pill, " ").concat(config !== null && config !== void 0 && (_config$i18n = config.i18n) !== null && _config$i18n !== void 0 && _config$i18n.debug ? styles.enabled : styles.disabled)
    }), "Live"),
    key: 'debug',
    onClick: function onClick() {
      var _config$i18n2;
      return onFeatureToggle('debug')(!(config !== null && config !== void 0 && (_config$i18n2 = config.i18n) !== null && _config$i18n2 !== void 0 && _config$i18n2.debug));
    }
  }, {
    label: /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("span", {
      className: "".concat(styles.pill, " ").concat(config !== null && config !== void 0 && (_config$i18n3 = config.i18n) !== null && _config$i18n3 !== void 0 && _config$i18n3.preventDefault ? styles.enabled : styles.disabled)
    }), "Prevent default"),
    key: 'preventDefault',
    onClick: function onClick() {
      var _config$i18n4;
      return onFeatureToggle('preventDefault')(!(config !== null && config !== void 0 && (_config$i18n4 = config.i18n) !== null && _config$i18n4 !== void 0 && _config$i18n4.preventDefault));
    }
  }, {
    label: /*#__PURE__*/React.createElement("span", null, "Refresh translations"),
    key: 'refresh',
    onClick: onRefresh
  }];
  return /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(Left, null, /*#__PURE__*/React.createElement("img", {
    src: logo,
    width: "30"
  })), /*#__PURE__*/React.createElement(Right, null, /*#__PURE__*/React.createElement(Space, null, !!(config !== null && config !== void 0 && config.impersonation) && /*#__PURE__*/React.createElement(Impersonation, null), /*#__PURE__*/React.createElement(Dropdown, {
    menu: {
      items: items
    },
    trigger: ['hover']
  }, /*#__PURE__*/React.createElement("span", {
    className: "".concat(styles.tag),
    onClick: onFeatureToggle('debug')
  }, /*#__PURE__*/React.createElement("span", {
    className: "".concat(styles.pill, " ").concat(config !== null && config !== void 0 && (_config$i18n5 = config.i18n) !== null && _config$i18n5 !== void 0 && _config$i18n5.debug ? styles.enabled : styles.disabled)
  }), "Traduction live")))));
};
export default NtqToolbar;